import { Alert, Button, Card, Center, Divider, Stack, Title } from '@mantine/core';
import { IconAlertCircle, IconLogin2 } from '@tabler/icons-react';
import { Navigate, useLocation } from 'react-router-dom';
import { useClientAuth } from '../../auth/index.js';
import { Logo } from '../../components/Logo/Logo.js';
import { STUDIOS_ROUTE } from '../../domain/routes.js';
import { readLoginRedirect } from './loginRedirect.js';

export const LoginPage = () => {
    const auth = useClientAuth();
    const location = useLocation();
    // Set by `App.tsx`'s route guard when it bounced an unauthenticated visit here: the page
    // that redirect dropped, restored once sign-in completes (`auth.signIn`, then
    // `auth/index.tsx`'s `onSigninCallback`).
    const target = readLoginRedirect(location.state);

    if (auth.isAuthenticated) return <Navigate to={target ?? STUDIOS_ROUTE} replace />;
    return (
        <Center mih="100dvh" p="md">
            <Card w="100%" maw={360} p="xl">
                <Stack gap="lg">
                    <Logo />
                    <Divider />
                    <Title order={3}>Sign in</Title>
                    {auth.error && (
                        <Alert color="red" icon={<IconAlertCircle size={16} stroke={1.7} />} p="sm">
                            {auth.error}
                        </Alert>
                    )}
                    <Button
                        fullWidth
                        leftSection={<IconLogin2 size={16} stroke={1.7} />}
                        loading={auth.isLoading}
                        onClick={() => auth.signIn(target ?? undefined)}
                    >
                        Continue with SSO
                    </Button>
                </Stack>
            </Card>
        </Center>
    );
};
